import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Identification from "@/components/landing/Identification";
import TheWall from "@/components/landing/TheWall";
import GateMethod from "@/components/landing/GateMethod";
import InsideProgram from "@/components/landing/InsideProgram";
import AlexStory from "@/components/landing/AlexStory";
import Guarantee from "@/components/landing/Guarantee";
import Path90 from "@/components/landing/Path90";
import NotForYou from "@/components/landing/NotForYou";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import MobileStickyCTA from "@/components/shared/MobileStickyCTA";
import OnyxWidgetMount from "@/components/shared/OnyxWidgetMount";

export default function Index() {
  return (
    <div className="bg-room min-h-screen relative grain">
      <Nav />
      <main className="relative">
        <Hero />
        <Identification />
        <TheWall />
        <GateMethod />
        <InsideProgram />
        <AlexStory />
        <Guarantee />
        <Path90 />
        <NotForYou />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <MobileStickyCTA />
      <OnyxWidgetMount />
    </div>
  );
}
